import { StyleSheet } from 'react-native';
import {
  ContentfulImage,
  type ContentfulImageTransformOptions,
  Image,
  useResponsive,
} from '@sg/garnish';

import { DefaultCustomizationBannerImage } from './assets';

// ─────────────────────────────────────────────────────────────────────────────

export const CustomizationBannerImage = (props: Props) => {
  const { alt, contentfulImageUrl } = props;

  const { match } = useResponsive();

  // ─── Contentful Image ──────────────────────────────────────────────────────

  if (contentfulImageUrl) {
    return (
      <ContentfulImage
        baseUrl={contentfulImageUrl}
        alt={alt}
        style={styles.image}
        contentFit="cover"
        contentPosition="bottom center"
        options={match([
          IMAGE_CONFIG_XS,
          IMAGE_CONFIG_SM,
          IMAGE_CONFIG_LG,
          IMAGE_CONFIG_XL,
        ])}
      />
    );
  }

  // ───────────────────────────────────────────────────────────────────────────

  return (
    <Image
      source={DefaultCustomizationBannerImage}
      alt={alt}
      style={styles.image}
      contentFit="cover"
      contentPosition="bottom center"
    />
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  image: {
    width: '100%',
    height: '100%',
  },
});

// ─── Constants ──────────────────────────────────────────────────────────────

const DEFAULT_CONFIG: ImageConfig = { fm: 'webp', fit: 'fill', q: 50 };

const IMAGE_CONFIG_XS: ImageConfig = { ...DEFAULT_CONFIG, w: 420 };
const IMAGE_CONFIG_SM: ImageConfig = { ...DEFAULT_CONFIG, w: 720 };
const IMAGE_CONFIG_LG: ImageConfig = { ...DEFAULT_CONFIG, w: 1080 };
const IMAGE_CONFIG_XL: ImageConfig = { ...DEFAULT_CONFIG, w: 1440 };

// ─── Types ───────────────────────────────────────────────────────────────────

type Props = {
  alt: string;
  contentfulImageUrl?: string;
};

type ImageConfig = Partial<ContentfulImageTransformOptions>;
